const TOKEN_KEY = 'auth_token';
const REFRESH_KEY = 'auth_refresh';
const USER_ID_KEY = 'auth_user_id';

function getItem(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function setItem(key: string, value: string) {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* quota or disabled storage */
  }
}

function removeItem(key: string) {
  try {
    localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

export const setAuth = async (token: string, userId: string, refreshToken?: string): Promise<void> => {
  setItem(TOKEN_KEY, token);
  setItem(USER_ID_KEY, userId);
  if (refreshToken) setItem(REFRESH_KEY, refreshToken);
};

export const setAccessToken = async (token: string): Promise<void> => {
  setItem(TOKEN_KEY, token);
};

export const setRefreshToken = async (token: string): Promise<void> => {
  setItem(REFRESH_KEY, token);
};

export const getToken = async (): Promise<string | null> => getItem(TOKEN_KEY);
export const getRefreshToken = async (): Promise<string | null> => getItem(REFRESH_KEY);
export const getUserId = async (): Promise<string | null> => getItem(USER_ID_KEY);

export const clearAuth = async (): Promise<void> => {
  removeItem(TOKEN_KEY);
  removeItem(REFRESH_KEY);
  removeItem(USER_ID_KEY);
};

export const isAuthenticated = async (): Promise<boolean> => getItem(TOKEN_KEY) !== null;
